import { M_SIPARIS_DETAY } from './../../../models/M_SIPARIS_DETAY';

import { BllSiparisDetay } from './../../../providers/bll/bll-siparis-detay';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';
import { OzetPage } from './../../faturaislemleri/ozet/ozet';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';


/**
 * Generated class for the UrunsecPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-urunsec',
  templateUrl: 'urunsec.html',
})
export class UrunsecPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  urunListesi=[];
  urunname:any={};
  miktar: number = 1;
  CariObj: any={};
  CariID: any;
  UrunObj:any={};
  SiparisID=-1;
 
  aktifSiparisVeDetaylari: any = { SIPARIS_BASLIK: {}, SIPARIS_DETAYLARI: [] };
  constructor(public bllOrtak: BllOrtak, public modalCtrl: ModalController, public view: ViewController, public navCtrl: NavController, public toast: ToastController, public navParams: NavParams) {
    this.CariID = navParams.get("cariID");
    this.CariObj = navParams.get("CariObj");

    
  }

  ionViewDidLoad() {
    this.urunAra(null);
  }
  presentToast(mesaj) {
    let toast = this.toast.create({
      message: mesaj,
      duration: 1000,
      showCloseButton: true,
      // closeButtonText: "Tamam",
      position: 'top'
    });
    toast.present();
    // this.sonEklenen = mesaj;
  }
  toggleDetails(data) {
    if (data.showDetails) {
      data.showDetails = false;
      data.icon = 'ios-add-circle-outline';
    } else {
      data.showDetails = true;
      data.icon = 'ios-remove-circle-outline';
    }
  }
  urunAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.urunListesi = sonuc.SonucObject;
   
 
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.urunAra(null);

    }
  }

  urunItemClick(urun) {

   

    var bllSiparisDetay = new BllSiparisDetay();
    //this.UrunObj.Name=this.urunname.Name;

    bllSiparisDetay.siparisDetayEkle_Temp(this.CariObj.LogicalRef,urun.LogicalRef,this.miktar,this.UrunObj.Name,8,1,urun.Price2,urun.Price1,255).then(a => {
      this.presentToast(urun.Name);//toast konacak
     
      
    });
  }

  siparisIDGetir(): number {
    var siparisID: number = -1;
    // siparisID = this.CariObj.siparislerVeDetaylari.filter(a => a.SIPARIS_BASLIK.LogicalRef == 1)[0].SIPARIS_BASLIK.LogicalRef;
    siparisID = this.CariObj.siparislerVeDetaylari
    return siparisID;
  }
  ozet() {
    let modal = this.modalCtrl.create(OzetPage, { CariObj: this.CariObj, UrunObj: this.UrunObj });
    modal.onDidDismiss(data => {
      if (data != null) {
        this.CariObj = data.CariObj;
        this.UrunObj = data.UrunObj;
        if (data.onaylandi != null) {
          if (data.onaylandi == true)
            this.view.dismiss();
        }
      }
    });
    modal.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/urunsec/urunsec.ts